/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Issuer } from '../models/Issuer';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class IssuersService {
    /**
     * @returns Issuer OK
     * @throws ApiError
     */
    public static getApiV1Issuers({
        groupId,
    }: {
        groupId?: number | string,
    }): CancelablePromise<Array<Issuer>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/Issuers',
            query: {
                'groupId': groupId,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }
    /**
     * @returns Issuer OK
     * @throws ApiError
     */
    public static getApiV1Issuers1({
        id,
    }: {
        id: number,
    }): CancelablePromise<Issuer> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/Issuers/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }
    /**
     * @returns Issuer OK
     * @throws ApiError
     */
    public static getApiV1IssuersByExternalId({
        externalId,
    }: {
        externalId: number,
    }): CancelablePromise<Issuer> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/Issuers/ByExternalId/{externalId}',
            path: {
                'externalId': externalId,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }
}
